



































































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import { TPPClaims } from "@/models/tpp-claims/TPPClaims";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import TPPClaimsSearch from "@/views/tpp-claims/partials/TPPClaimsSearch.vue";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";
import { footerProps } from "@/helpers/footer-props";
import { formatDate } from "@/helpers/functions/format-date";
import { tppClaimsHeader } from "@/helpers/tpp-claims/tpp-claims-data-table-headers";
import { truncateContent } from "@/helpers/functions/truncate-content";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "TPPClaimsTable",
  components: { TPPClaimsSearch }
})
export default class TPPClaimsTable extends Vue {
  // ===== Props ===== //

  // ===== State ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("getTPPClaims") public getTPPClaims!: () => void;
  @tppClaims.Action("handleSelectedTPPClaim") public handleSelectedTPPClaim!: (payload: TPPClaims) => void;

  // ===== Data ===== //
  public headers = tppClaimsHeader;
  public footerProps = footerProps;

  // ===== Methods ===== //
  private formatDate = formatDate;
  private truncateContent = truncateContent;

  private async handleViewTPP(tppClaim: TPPClaims): Promise<void> {
    await this.handleSelectedTPPClaim(tppClaim);
    await this.$router.push({ name: "tppClaimsView", params: { claimNumber: tppClaim.claim_number } });
  }

  private formatStatus(status: string): string {
    return status.replace("_", " ");
  }

  // ===== Computed ===== //

  // ===== Lifecycle ===== //
  private created() {
    if (this.tppClaims.tppClaimsList && !this.tppClaims.tppClaimsList.length) {
      this.getTPPClaims();
    }
  }
}
